import  { ADD_TIME_SLOT, BOOKING_TIME_SLOT, BOOKING_TIME_SLOT_ERROR } from  '../actions/ActionTypes';
import api from '../api'
import { MESSAGE } from "../helpers/constants"
import { toast } from 'react-toastify';

export function getbookingTimeSlot() {
    return function (dispatch) {
        api.get('booking-time-slots/').then(async (response) => {
            if (response.status === "success") {
                await dispatch({
                    type: BOOKING_TIME_SLOT,
                    data: response.payload
                });
            }
        });
    }
}

export function bookingTimeSlot(router, data) {
	return function (dispatch) {
        api.post("booking-time-slots/", data).then(async (response) => {
            if (response.status === "success") {
                api.get('booking-time-slots/').then((response) => {
                    if (response.status === "success") {
                        toast.success(MESSAGE.booking_time_slot, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                        dispatch({
                            type: BOOKING_TIME_SLOT,
                            data: response.payload
                        });
                    }
                });
                await dispatch({
                    type: ADD_TIME_SLOT,
                    data: response.payload
                });
            }
            else {
                toast.error(response.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                await dispatch({
                    type: BOOKING_TIME_SLOT_ERROR,
                    data: response.message
                });
            }
        })
    }
}
export function UpdateBookingTimeSlot(data,id){
	return function(dispatch){

		api.put("booking-time-slots/"+id, data).then(async (response) => {
			if (response.status === "success") {
                api.get('booking-time-slots/').then((response) => {
                    if (response.status === "success") {
                        toast.success(MESSAGE.booking_time_slot_update, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                        dispatch({
                            type: BOOKING_TIME_SLOT,
                            data: response.payload
                        });
                    }
                });
                await dispatch({
                    type: ADD_TIME_SLOT,
                    data: response.payload
                });
            }
            else {
                toast.error(response.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
                await dispatch({
                    type: BOOKING_TIME_SLOT_ERROR,
                    data: response.message
                });
            }
        })
    }
}